export function resolveVariantId(drainState) {
  if (!drainState || drainState.available === false) return null;
  const resolved = normalizeVariantId(drainState.resolvedVariantId);
  if (resolved) return resolved;
  const intended = normalizeVariantId(drainState.intendedVariantId);
  if (intended) return intended;
  const hidden = normalizeVariantId(drainState.hiddenInputValue);
  if (hidden) return hidden;
  return null;
}
function normalizeVariantId(value) {
  if (value == null) return null;
  const trimmed = String(value).trim();
  return trimmed.length > 0 ? trimmed : null;
}
